<template>
  <div
    ref="export-card"
    class="export-card"
    :class="{
      'export-card--removing': isRemoving
    }"
    @mouseenter="$emit('mouseenterEl')"
  >
    <a-icon
      :type="loadingRemove ? 'loading' : 'close-circle'"
      class="close"
      @click.stop="$emit('remove')"
    />

    <div class="py-3">
      <div
        v-if="isDone"
        class="d-flex align-items-center"
        style="gap: 20px;"
      >
        <a-icon type="check-circle" class="font-size-18 text-success" />

        <div
          class="d-flex flex-column"
          style="max-width: 200px;"
        >
          <span class="font-weight-bold">
            Export ready
          </span>

          <HideLongText :value="exportItem.filename" />
        </div>

        <div class="flex export-actions">
          <a-button
            type="primary"
            size="small"
            :disabled="isExporting || isRemoving"
            @click.stop="$emit('export')"
          >
            <a-icon v-if="isExporting" type="loading" />
            <a-icon v-else type="upload" />
          </a-button>
        </div>
      </div>

      <div
        v-else
        class="d-flex align-items-center"
        style="gap: 20px;"
      >
        <a-icon type="upload" class="font-size-18" />

        <div class="d-flex flex-column w-full">
          <HideLongText :value="`Preparing ${exportCategory} export…`" />

          <a-progress
            type="line"
            :percent="exportItem.progress"
            :status="progressStatus"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HideLongText from '@/components/custom/HideLongText.vue'

export default {
  components: {
    HideLongText,
  },
  props: {
    exportItem: Object,
    isRemoving: {
      type: Boolean,
      default: false,
    },
    loadingRemove: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progressStatus() {
      if (this.exportItem?.exportStatus === 'fail') {
        return 'exception'
      }

      if (!this.exportItem?.isDoneExport) {
        return 'active'
      }

      return 'success'
    },
    isExporting() {
      return this.$store.getters['exports/isExporting'](this.exportItem?.id)
    },
    isDone() {
      return this.exportItem.is_done
    },
    exportCategory() {
      return this.exportItem.filename.split('_')[0]
    },
  },
}
</script>

<style scoped lang="scss">
.export-card {
  position: relative;
  width: 320px;
  min-height: 75px;
  height: 75px;
  background: #fff;
  border-radius: 12px;
  box-shadow:
    0 8px 24px rgba(0,0,0,0.12),
    0 2px 8px rgba(0,0,0,0.08);

  padding: 0 12px;
  will-change: transform, opacity;
  transition:
    transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.25s ease,
    box-shadow 0.25s ease;
    height: 0.4s ease;
    min-height: 0.4s ease;
  &--removing {
    min-height: 0;
    height: 0;
    opacity: 0;
    transform: translateX(120px), scale(0.5);
  }
  &:hover {
    box-shadow:
      0 14px 34px rgba(0,0,0,0.18),
      0 4px 12px rgba(0,0,0,0.1);
    .close {
      opacity: 1;
      transform: scale(1);
      pointer-events: auto;
    }

    .export-actions {
      transform: translateY(8px);
    }
  }
}
.export-actions {
  transition:
    transform 0.25s ease,
    margin-top 0.25s ease;
}
.close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 16px;
  height: 16px;
  font-size: 16px;
  color: #c8c4db;

  opacity: 0;
  transform: scale(0.8);
  pointer-events: none;

  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    color 0.2s ease;
  &:hover {
    color: #f5222e;
    transform: scale(1.15);
    cursor: pointer;
  }
}
</style>
